import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: 'Α/Α', fieldType: 'INT' },
    { fieldName: 'name', fieldTitle: 'Επωνυμία', fieldType: 'TEXT' },
    { fieldName: 'vatNumber', fieldTitle: 'Α.Φ.Μ.', fieldType: 'TEXT' },
    { fieldName: 'taxOffice', fieldTitle: 'Δ.Ο.Υ.', fieldType: 'TEXT' },
    { fieldName: 'contactPerson', fieldTitle: 'Υπεύθυνος', fieldType: 'TEXT' },
    { fieldName: 'addressLine1', fieldTitle: 'Διεύθυνση', fieldType: 'TEXT' },
    { fieldName: 'addressLine2', fieldTitle: 'Διεύθυνση 2', fieldType: 'TEXT' },
    { fieldName: 'addressArea', fieldTitle: 'Περιοχή', fieldType: 'TEXT' },
    { fieldName: 'addressCity', fieldTitle: 'Πόλη', fieldType: 'TEXT' },
    { fieldName: 'postalCode', fieldTitle: 'Τ.Κ.', fieldType: 'TEXT' },
    { fieldName: 'phoneNumber1', fieldTitle: 'Τηλ.1', fieldType: 'TEXT' },
    { fieldName: 'phoneNumber2', fieldTitle: 'Τηλ.2', fieldType: 'TEXT' },
    { fieldName: 'mobileNumber1', fieldTitle: 'Κινητό', fieldType: 'TEXT' },
    { fieldName: 'email', fieldTitle: 'e-mail', fieldType: 'TEXT' },
    { fieldName: 'cntContributorsGroup.name', fieldTitle: 'Κατηγορία Υπόχρεου', fieldType: 'TEXT' },
    {
      fieldName: 'cntContributionsPeriodgroup.name',
      fieldTitle: 'Περιοδικότητα δηλώσεων',
      fieldType: 'TEXT',
    },
    { fieldName: 'producerRegNum', fieldTitle: 'ΑΜΠ', fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: 'Ενεργό', fieldType: 'BOOLEAN' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCntContributors.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getCntContributors: { data: recs, recordCount: data?.getCntContributors?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Contributors',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
